export default {
  "member": "Staff member",
  "avatar": "Staff avatar",
  "viewAvatar": "View avatar for {name}",
  "search": "Search staff by name or email",
  "allStatuses": "All Statuses",
  "allRoles": "All Roles",
  "name": "Name",
  "role": "Role",
  "status": "Status",
  "certifications": "Certifications",
  "joined": "Joined",
  "joinedDate": "Joined {date}",
  "actions": "Actions",
  "grid": "Grid view",
  "list": "List view",
  "active": "Active",
  "inactive": "Inactive",
  "call": "Call staff member",
  "message": "Message staff member",
  "noExtension": "No extension assigned",
  "noExtensionBody": "This staff member does not have a phone extension assigned.",
  "callFailed": "Unable to open the dialler",
  "conversationFailed": "Unable to open conversation",
  "profileMissing": "We couldn’t determine your staff profile for messaging.",
  "selfMessage": "Cannot message yourself",
  "selectOther": "Please select another staff member.",
  "retry": "Please try again.",
  "loadError": "Unable to load staff. Please try again.",
  "restricted": "You do not have access to these staff records.",
  "empty": "No staff found",
  "emptyHelp": "Try adjusting your filters or search terms.",
  "loading": "Loading staff…",
  "oneResult": "{count} staff member",
  "manyResults": "{count} staff members",
  "clear": "Clear filters",
  "noCertifications": "No certifications",
  "noReports": "No direct reports",
  "noManager": "No reporting manager assigned",
  "noMatches": "No matching staff",
  "select": "Select {name}",
  "certificationExpired": "{name} · Expired {date}"
}
